import { FunctionComponent, useEffect, useState } from 'react'
import styled from 'styled-components'
import { styles } from '../../../../styles/themes/style'

import Text from '../../../../components/Text'
import SvgFragment from '../../../../fragments/SvgFragment'
import { useAuthHandlers } from '../../../../services/actions/auth/useAuthHandlers'
import { useAppHandlers } from '../../../../services/actions/app/useAppHandlers'

interface IDemoVideoStyles {
    show?: boolean
}

interface IDemoVideoProps {
    onClick?: (e: any) => void
}

const DemoVideo: FunctionComponent<IDemoVideoProps> = ({ onClick }) => {
    const { saveUserPreferencesHandler } = useAuthHandlers()
    const { showInfoToast } = useAppHandlers()

    const [visible, setVisible] = useState(false)

    useEffect(() => {
        setTimeout(() => setVisible(true), 1000)
    }, [])

    const videoSrc = "https://www.loom.com/embed/e8fdd0aef606407a984379515b119789?sid=44f3f1e6-2217-42a2-9948-a94cee931e1f?autoplay=true&hide_owner=true&hide_share=true&hide_title=true&hideEmbedTopBar=true" 

    const onClickHandler = () => {
        setVisible(false)
        setTimeout(() => {
            onClick && onClick(true)
            saveUserPreferencesHandler({hideDemoVideo: true})
            showInfoToast({message: 'You can still watch the demo video anytime on your LeadDelta home page'})
        }, 500) // Match the transition duration
    }

    return (
        <Container show={visible}>
        <Wrapper>
            <Header>
                <Text $heading3>Watch a quick intro video</Text>
                <StyledSvgFragmentWrapper onClick={onClickHandler}>
                    <SvgFragment type='close' />
                </StyledSvgFragmentWrapper>
            </Header>
            <StyledText>Explore how to simplify connection management, organize your network, and build stronger professional relationships.</StyledText>
            <VideoFrameWrap>
                <StyledDemoVideoFrame src={videoSrc} allowFullScreen frameBorder="0" />
            </VideoFrameWrap>
        </Wrapper>
    </Container>
    )
}

const Container = styled.div<IDemoVideoStyles>`
    position: fixed;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 50px 16px 16px;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    background-color: ${styles.colors.black600}B3;
    z-index: 1007;
    top: 0px;
    overflow-y: auto;

    opacity: ${({show}) => (show ? 1 : 0)};
    transition: opacity 0.5s ease-in-out;

    @media (max-width: 768px) {
        padding: 16px;
        align-items: center;
    }
`
const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: min(690px, 100%);
    max-height: calc(100vh - 32px);
    background-color: white;
    padding: 24px;
    border-radius: 12px;
    overflow: hidden;
    box-sizing: border-box;

    @media (max-width: 768px) {
        padding: 16px;
        max-height: calc(100vh - 32px);
        overflow-y: auto;
    }
`
const Header = styled.div`
    display: flex;
    position: relative;
    width: 100%;
    justify-content: center;
    align-items: center;
`
const StyledSvgFragmentWrapper = styled.div`
    cursor: pointer;
    position: absolute;
    right: -10px;
    top: -10px;

    @media (max-width: 768px) {
        right: -5px;
        top: -5px;
    }
`
const StyledText = styled(Text)`
    text-align: center;
`
const VideoFrameWrap = styled.div`
    width: 100%;
    max-width: 640px;
    aspect-ratio: 16 / 9;
    margin-top: 16px;
    border-radius: 12px;
    overflow: hidden;
`

const StyledDemoVideoFrame = styled.iframe<IDemoVideoStyles>`
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 12px;
`

export default DemoVideo